import React from "react";
import "./TokenUtility.css";
import { Link } from "react-router-dom";
import LogoIcon from '../../../assets/img/logo-icon.png'
const TokenUtility = () => {
  return (
    <div className="utility-area AboutToken_section__aU1MY">
      <div className="Container_container__GUjyn AboutToken_container__YNtK7">
        <div className="AboutToken_tokenImage__yqs05" style={{ opacity: 1 }}>
          <div
            className="Token_token__kdWCG AboutToken_token__zwp6B"
            style={{ opacity: 1 }}
          >
            <div className="Token_wrap__1SPDg">
              <img src={LogoIcon} height="100" className="logo-utility" />
            </div>
          </div>
        </div>
        <div className="AboutToken_info__kqlt9" style={{ opacity: 1 }}>
          <button
            className="Button_button__Wx62k Button_size-xs__ucLSX Button_color-white__WRROn Button_background-dark-cyan__BT+yU AboutToken_buttonCategory__6pk84"
            type="button"
          >
            <span>
              <div className="Typography_font-size-m__NA6mG Typography_color-light-cyan__8c+gR Typography_weight-600__xD5tQ Typography_line-height-150__1QAw-">
                Token Utility
              </div>
            </span>
          </button>
          <div className="AboutToken_securedBy__K20wJ">
            <div className="Typography_font-size-xl__X+CRm Typography_color-white__0vcsJ Typography_weight-700__3PDWn Typography_line-height-120__+PGc9 AboutToken_title__8aMud">
              Powered by $SAPI
            </div>
            <div className="AboutToken_lineFlip__2Ztq4" />
          </div>
          <div className="AboutToken_list__5ZN8j">
            <div className="Typography_font-size-sm__ceGXz Typography_color-gray-400__Wjkwf Typography_weight-400__yKCCf Typography_line-height-162__m4nqy AboutToken_item__NlY77">
              <svg
                width={18}
                height={32}
                viewBox="0 0 18 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3347 16.6752L9.69057 14.0013L15.0985 0L0.5 15.3248L8.1441 17.9987L2.7362 32L17.3347 16.6752Z"
                  fill="#0B0C0F"
                />
              </svg>
              <span>IDO Participation</span>
            </div>
            <div className="Typography_font-size-sm__ceGXz Typography_color-gray-400__Wjkwf Typography_weight-400__yKCCf Typography_line-height-162__m4nqy AboutToken_item__NlY77">
              <svg
                width={18}
                height={32}
                viewBox="0 0 18 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3347 16.6752L9.69057 14.0013L15.0985 0L0.5 15.3248L8.1441 17.9987L2.7362 32L17.3347 16.6752Z"
                  fill="#0B0C0F"
                />
              </svg>
              <span>Guaranteed Allocation</span>
            </div>
            <div className="Typography_font-size-sm__ceGXz Typography_color-gray-400__Wjkwf Typography_weight-400__yKCCf Typography_line-height-162__m4nqy AboutToken_item__NlY77">
              <svg
                width={18}
                height={32}
                viewBox="0 0 18 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3347 16.6752L9.69057 14.0013L15.0985 0L0.5 15.3248L8.1441 17.9987L2.7362 32L17.3347 16.6752Z"
                  fill="#0B0C0F"
                />
              </svg>
              <span>Fee Distribution</span>
            </div>
            <div className="Typography_font-size-sm__ceGXz Typography_color-gray-400__Wjkwf Typography_weight-400__yKCCf Typography_line-height-162__m4nqy AboutToken_item__NlY77">
              <svg
                width={18}
                height={32}
                viewBox="0 0 18 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3347 16.6752L9.69057 14.0013L15.0985 0L0.5 15.3248L8.1441 17.9987L2.7362 32L17.3347 16.6752Z"
                  fill="#0B0C0F"
                />
              </svg>
              <span>Private Deals & Airdrops</span>
            </div>
            <div className="Typography_font-size-sm__ceGXz Typography_color-gray-400__Wjkwf Typography_weight-400__yKCCf Typography_line-height-162__m4nqy AboutToken_item__NlY77">
              <svg
                width={18}
                height={32}
                viewBox="0 0 18 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3347 16.6752L9.69057 14.0013L15.0985 0L0.5 15.3248L8.1441 17.9987L2.7362 32L17.3347 16.6752Z"
                  fill="#0B0C0F"
                />
              </svg>
              <span>Governance</span>
            </div>
            <div className="Typography_font-size-sm__ceGXz Typography_color-gray-400__Wjkwf Typography_weight-400__yKCCf Typography_line-height-162__m4nqy AboutToken_item__NlY77">
              <svg
                width={18}
                height={32}
                viewBox="0 0 18 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3347 16.6752L9.69057 14.0013L15.0985 0L0.5 15.3248L8.1441 17.9987L2.7362 32L17.3347 16.6752Z"
                  fill="#0B0C0F"
                />
              </svg>
              <span>Ecosystem Discounts</span>
            </div>
          </div>
          <div className="AboutToken_buttons__b4RAh">
            <a
              className="TextLink_external__NRuKX"
              href="https://blog.lightlink.io/ll-tokenomics/"
              target="_blank"
              rel="noreferrer"
            >
              <div className="Typography_font-size-m__NA6mG Typography_color-light-cyan__8c+gR Typography_weight-500__FcutR Typography_line-height-150__1QAw- TextLink_link__SVI+7 TextLink_color-light-cyan__ecspA">
                <Link
                  to="/launchpad/public-sale"
                  className="Button_button__Wx62k Button_size-m__1Togf Button_color-white__WRROn2 Button_type-outlined__WkOrN btn-learn-more"
                  type="button"
                >
                  <span className="font-weight-bold">Learn more</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="#F7931A"
                    className="css-aw5qf7"
                  >
                    <path
                      d="M7.33324 3.33343C6.96505 3.33343 6.66658 3.63191 6.66658 4.00009C6.66658 4.36829 6.96506 4.66677 7.33326 4.66676L10.3906 4.66671L4.80915 10.1953C4.54669 10.4553 4.54568 10.8791 4.8069 11.1404C5.06637 11.3998 5.48675 11.4008 5.74745 11.1426L11.3335 5.60945L11.334 8.66676C11.334 9.03492 11.6325 9.33334 12.0007 9.33334C12.3689 9.33334 12.6674 9.03482 12.6673 8.66659L12.6669 4.33329C12.6669 3.78104 12.2192 3.33338 11.6669 3.33338L7.33324 3.33343Z"
                      fill="#F7931A"
                    />
                  </svg>
                </Link>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenUtility;
